import { useState } from "react";
import "./AddPageComponent.css";

export default function AddPageComponent({ onAddPage, projectId }) {
    const [isOpen, setIsOpen] = useState(false);
    const [pageName, setPageName] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!pageName.trim()) return;

        setIsLoading(true);
        try {
            await onAddPage?.(pageName.trim());
            setPageName("");
            setIsOpen(false);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setPageName("");
        setIsOpen(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            handleCancel();
        }
    };

    if (!isOpen) {
        return (
            <button 
                className="add-page-btn"
                onClick={() => setIsOpen(true)}
            >
                <span className="add-page-icon">+</span>
                <span className="add-page-text">Nouvelle page</span>
            </button>
        );
    }

    return (
        <div className="add-page-form-wrapper">
            <form className="add-page-form" onSubmit={handleSubmit}>
                <div className="add-page-form-header">
                    <span className="add-page-form-icon">📄</span>
                    <span className="add-page-form-title">Nouvelle page</span>
                </div>
                
                <input
                    type="text"
                    className="add-page-input"
                    placeholder="Nom de la page..."
                    value={pageName}
                    onChange={(e) => setPageName(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoFocus
                    disabled={isLoading}
                />
                
                <div className="add-page-actions">
                    <button 
                        type="button" 
                        className="add-page-cancel-btn"
                        onClick={handleCancel}
                        disabled={isLoading}
                    >
                        Annuler
                    </button>
                    <button 
                        type="submit" 
                        className={`add-page-submit-btn ${isLoading ? 'loading' : ''}`}
                        disabled={!pageName.trim() || isLoading}
                    >
                        {isLoading ? (
                            <span className="add-page-spinner"></span>
                        ) : (
                            <>
                                <span>+</span> Créer
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

